var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0873 8.0606C15.1947 4.7393 12.3606 3.00002 9.45136 3C6.54199 2.99997 3.70792 4.73921 1.81531 8.06052C1.48344 8.64292 1.48344 9.35697 1.81531 9.93936C3.70791 13.2606 6.54199 14.9999 9.45127 15C12.3606 15 15.1947 13.2607 17.0873 9.93945C17.4192 9.35706 17.4192 8.643 17.0873 8.0606ZM9.11476 6.67082L8.50609 7.8882C8.46981 7.96076 8.41096 8.01961 8.33839 8.0559L7.12101 8.66458C6.84462 8.80279 6.84462 9.19722 7.12101 9.33537L8.33839 9.94413C8.41096 9.9804 8.46981 10.0393 8.50609 10.1118L9.11476 11.3291C9.253 11.6055 9.64738 11.6055 9.78562 11.3291L10.3943 10.1118C10.4306 10.0393 10.4894 9.9804 10.562 9.94413L11.7794 9.33537C12.0558 9.19722 12.0558 8.80279 11.7794 8.66459L10.562 8.0559C10.4894 8.01961 10.4306 7.96076 10.3943 7.8882L9.78562 6.67082C9.64738 6.39442 9.253 6.39442 9.11476 6.67082Z",
    fill: "#0F55DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM06);
export default __webpack_public_path__ + "static/media/m_06.a4d27ce46850f8b56bd9b3522eb4751e.svg";
export { ForwardRef as ReactComponent };